import { render, staticRenderFns } from "./PscMain.vue?vue&type=template&id=79868441&scoped=true&"
import script from "./PscMain.vue?vue&type=script&lang=js&"
export * from "./PscMain.vue?vue&type=script&lang=js&"
import style0 from "./PscMain.vue?vue&type=style&index=0&id=79868441&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79868441",
  null
  
)

export default component.exports